module.exports = __webpack_public_path__ + "img/no-finalize.ddbe9389.svg";